import { T } from '../lib/hook/useI18n';

/**
 * @see https://github.com/referenceable/referenceable_api/blob/develop/app/graphql/application/types/rooms/room_status_enum_type.rb
 */
export enum RoomStatus {
  ACTIVE = 'ACTIVE',
  DRAFT = 'DRAFT',
  INACTIVE = 'INACTIVE',
}

export const STATUS_OPTIONS = [
  {
    title: 'Published',
    value: RoomStatus.ACTIVE,
  },
  {
    title: 'Draft',
    value: RoomStatus.DRAFT,
  },
  {
    title: 'Disabled',
    value: RoomStatus.INACTIVE,
  },
];

export const getStatusOptions = (t: T) => [
  {
    title: t('rooms.filter.status.published'),
    value: RoomStatus.ACTIVE,
  },
  {
    title: t('rooms.filter.status.draft'),
    value: RoomStatus.DRAFT,
  },
  {
    title: t('rooms.filter.status.disabled'),
    value: RoomStatus.INACTIVE,
  },
];
